import { Goal } from '@/types/goal';
import { ETypeTag } from '@/components/ETypeTag';
import { Trophy } from 'lucide-react';
import { useDateFormat } from '@/contexts/DateFormatContext';

interface CompletedGoalCardProps {
  goal: Goal;
}

export const CompletedGoalCard = ({ goal }: CompletedGoalCardProps) => {
  const { formatDate } = useDateFormat();

  return (
    <div className="rounded-lg p-4 border border-border/30 bg-card/50 opacity-80 hover:opacity-100 transition-opacity">
      <div className="flex items-start gap-3">
        <div className="p-1.5 rounded-md bg-yellow-500/10 mt-0.5">
          <Trophy className="w-4 h-4 text-yellow-500" />
        </div>
        <div className="flex-1 min-w-0 space-y-1.5">
          <p className="font-medium line-through text-muted-foreground">{goal.title}</p>
          <div className="flex flex-wrap items-center gap-2">
            {goal.eTypes.map((type) => (
              <ETypeTag key={type} type={type} />
            ))}
            <span className="text-xs text-muted-foreground/70">
              Completed {formatDate(goal.createdAt)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
